export default __webpack_public_path__ + "static/media/blog8.c972d7e4.jpg";